// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"247d7c3b","845":"17ea793b"}[chunkId] + ".chunk.js";
};